export const MAINNET = 56
export const AVALANCHE = 43114
export const TESTNET = 97
export const ARBITRUM_TESTNET = 421611
export const ARBITRUM = 42161
export const MOONBEAM = 1284
export const MOONBASE = 1287
